(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-destroy-panel-content', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                let panel_ids = lodash.get(options, 'panel_ids', null);
                if (!panel_ids) {
                    return false;
                }

                if (!(panel_ids instanceof Array)) {
                    panel_ids = [panel_ids];
                }

                panel_ids.map(function(panel_id) {
                    PanelManager.destroy(panel_id);
                });
                return true;
            }
        };
    }
})();